








import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { EventBus } from '../../event-bus';
import { FilterState } from '../../stores/modules/filter';

const filter = namespace('filter');

@Component({
  components: {}
})
export default class TypeSelect extends Vue {
  private checkboxValue: boolean = false;

  @filter.Mutation('setFilterItem') setItemFilter!: (a: {
    key: keyof FilterState['filter'];
    val: string | null;
  }) => void;

  @Watch('checkboxValue')
  onCheckboxChange(val: boolean) {
    let _val: string | null = val === true ? null : 'main';
    this.setItemFilter({ key: 'type', val: _val });
  }

  mounted() {
    EventBus.$on('reset-filter', () => {
      this.checkboxValue = false;
    });
  }
}
